import React, { useEffect } from "react";
import Home from "./components/Home";
import "./styles/app.css";
import { useSelector } from "react-redux";
import LoginPage from "./components/LoginPage";
import { useDispatch } from "react-redux";
import user_login, { setInboxCount, setUserLoginData, theme_color_change } from "./reduxContainer/StateActions";
import { emailsRef, usersRef } from "./firebase";
import LoadingPage from "./components/LoadingPage";
import swal from "sweetalert";


// fetch users data from firebase using email id 
export const fetchUserProfileData = async (email_id) => {
  try {
    const doc = await usersRef.doc(email_id).get();
    if (doc.exists) {
      const data = doc.data();
      // console.log(data);
      return data;
    } else {
      console.log("No such document!");
      return null;
    }
  } catch (error) {
    console.log("Error fetching document:", error);
    return null;
  }
};

// fetch all email ids in users collection 
export const getUsersCollectionIds = async () => {
  const snapshot = await usersRef.get();
  const ids = snapshot.docs.map((doc) => doc.id);
  return ids;
};

const fetchUserData = async (dispatch, themeColor) => {
  const data = localStorage.getItem('InfyMailBoxAppToken');
  const obj = JSON.parse(data);
  if (data) {
    dispatch(user_login(true));
    const firebase_users_data = await fetchUserProfileData(obj.email);
    const updated_users_data = {
      ...firebase_users_data,
      photoURL: firebase_users_data.profileImage_path !== null ? firebase_users_data.profileImage_path : obj.photoURL
    }
    dispatch(setUserLoginData(updated_users_data));
    dispatch(theme_color_change(firebase_users_data.theme_color || themeColor));
  } else {
    dispatch(user_login(false));
  }
};


function App() {
  const userState = useSelector((state) => state.userState);
  const themeColor = useSelector((state) => state.themeColor);
  const usersData = useSelector((state) => state.userData);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchUserData(dispatch, themeColor);
    // eslint-disable-next-line
  }, [userState, themeColor]);


  // inbox mail count
  useEffect(() => {
    emailsRef
      .where('to', '==', usersData.email)
      .onSnapshot(snapshot => {
        const emailArrays = snapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        }))
        dispatch(setInboxCount(emailArrays.filter(email => !email.data.opened && email.data.to === usersData.email).length));
      })
    // eslint-disable-next-line
  }, [usersData]);

  useEffect(() => {
    const isMobile = /Mobi/.test(navigator.userAgent);
    if (isMobile) {
      const timer = setTimeout(() => {
        swal("Open this app from computer to get better experience")
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      {!userState ? (
        <LoginPage />
      ) : (
        usersData.photoURL ? <Home /> : <LoadingPage />
      )}
    </>
  );
}

export default App;
